<template>
<div class="announcement-notifications" v-if="items.length > 0 && isShow">
	<div class="announcement-container">
		<div class="close-announcement">
			<i class="material-icons pointer" @click="close()">close</i>
		</div>
		<div class="announcement-notifications-wrapper">
			<div class="announcement-item" v-for="(item, index) in items" :key="index">
				<div class="announcement-title">{{ item.title }}</div>
				<div class="announcement-content" v-html="parsedContent(item.content)"></div>
			</div>
		</div>
	</div>
</div>
</template>

<script>

import announcementApi from '@/api/announcement';

export default {
	name: 'AnnouncementNotifications',
	components: {},
	data() {
		return {
			isShow: true,
			items: [],
			isFetching: false,
		};
	},
	sockets: {
	},
	mounted() {},
	created() {
		this.fetchList();
	},
	destroyed() {},
	beforeDestroy() {
	},
	computed: {},
	methods: {
		close() {
			this.isShow = false;
		},
		fetchList() {
			const params = {};
			this.isFetching = true;
			const callback = (response) => {
				this.items = response;
				this.isFetching = false;
			};
			const errorCallback = (error) => {
				const message = error.response.data.message;
				this.$notify({
					group: 'foo-velocity',
					title: 'Error',
					text: message,
					type: 'error',
				});
				this.isFetching = false;
			};
			announcementApi.activeList(params, callback, errorCallback);
		},
		parsedContent(text) {
			const content = text.replace(/\n/g, '<br>');
			return content;
		},
	},
};
</script>

<style lang="scss" scoped>
.announcement-notifications {
	position: fixed;
	bottom: 0;
	width: 100%;
	padding: 1.5em 2em;
	background-color: #C00100;
	color: #fff;
	z-index: 999;
	.announcement-container {
		position: relative;
	}
	.announcement-notifications-wrapper {
		overflow-y: auto;
		height: 60px;
	}
	.announcement-item {
		margin-bottom: 1.3em;
	}
	.announcement-title {
		font-weight: bold;
	}
	.announcement-content {}
	.close-announcement {
		position: absolute;
		right: -25px;
		top: -15px;
	}
}
</style>
